export default __webpack_public_path__ + "static/media/YUAN400_360_mobile.d0070e8f.jpg";